// shared-lib/fixture-types/hoodForm.js
//
// Which of its three builds a vent hood is, read off its `dimensions` alone —
// the ONE rule the renderer, the schematic and the estimate share
// (`genericVariants.FORM_DIMENSION_KEYS` keeps both keys through a width
// pick, so they are which appliance this is, not measurements):
//
//   'island'   `floating`: an island or peninsula hood hung from the ceiling,
//              its chimney rising to it
//   'chimney'  a `chimneyHeight` and no `floating`: a WALL chimney hood, a
//              duct cover drawn above it
//   'canopy'   neither: a plain canopy under a cabinet or between the uppers
//
// Pure.

const hoodFormOf = (dims = {}) => {
  if (dims?.floating === true) return 'island';
  return (dims?.chimneyHeight || 0) > 0 ? 'chimney' : 'canopy';
};

const HOOD_TYPES = new Set(['vent-hood', 'range-hood']);

/**
 * A Venus wood range hood (2026-10-31, `cabinet-runs/woodHoods`): a hood
 * carrying the SKU it is. NOT a form key on `dimensions` — the metal width
 * tiles carry the form keys through a pick, and would carry the wood build
 * with them (claude-docs/2026-10-30-venus-full-line-design.md, group 2).
 */
const isWoodHood = (obj) =>
  HOOD_TYPES.has(obj?.type) && typeof obj?.hoodSku === 'string';

/**
 * Which build a hood object is — `'wood'` for a Venus wood hood, else its
 * metal form (`hoodFormOf`) — the one rule the renderer, the schematic and
 * the estimate dispatch on.
 */
const hoodBuildOf = (obj) =>
  isWoodHood(obj) ? 'wood' : hoodFormOf(obj?.dimensions);

module.exports = { hoodFormOf, isWoodHood, hoodBuildOf };
